import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import * as moment from "moment";
import * as CryptoJS from "crypto-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  option: any;
  prod: any = [];
  appConstant: any;
  app_language: any;
  UpdateArray(newObject: any) {
    this.prod = newObject;
  }

  constructor(private http: HttpClient) {
    this.appConstant = environment;
    this.app_language = JSON.parse(
      localStorage.getItem(environment.localStorageLangKey)
    );
    const headers = new HttpHeaders()
      .set("language", this.app_language)
      .set("Content-Type", "application/x-www-form-urlencoded");

    this.option = { headers };
  }

  firstStep(data: any): Observable<any> {
    const body = new HttpParams()
      .set("country_code", data.code)
      .set("mobile_number", data.mobile)
      .set("email", data.email.toLowerCase())
      .set("type", data.type);

    return this.http
      .post(environment.authApiUrl + "SignUpFirstStep", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.statusText,
            message: error.error.message,
          });
        })
      );
  }

  secondStep(data: any): Observable<any> {
    const decryptedData = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("signup_first"),
        environment.secretkey
      ).toString(CryptoJS.enc.Utf8)
    );
    const body = new HttpParams()
      .set("code", data)
      .set("mobile_number", decryptedData.mobile_number)
      .set("email", decryptedData.email)
      .set("type", decryptedData.type)
      .set("OTP_token", decryptedData.OTP_token)
      .set("country_code", decryptedData.country_code);

    return this.http
      .post(environment.authApiUrl + "mobileVerify", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.statusText,
          });
        })
      );
  }

  signUpCompleted(data: any): Observable<any> {
    if (!data.gender) {
      data.gender = "";
    }

    let body = new HttpParams()
      .set("verify_token", data.verify_token)
      .set("name", data.name)
      .set("password", data.password)
      .set("confirm_password", data.confirm_password)
      .set("gender", data.gender)
      .set("date_of_birth", moment(data.date_of_birth).format("YYYY-MM-DD"))
      // .set("subscription_type", data.subscription_type ? data.subscription_type :"")
      .set("email", data.email)
      .set("device_id", data.device_id);
    if (data.one_signal_id) {
      body = body.set("one_signal_id", data.one_signal_id);
    }

    return this.http
      .post(environment.authApiUrl + "signUpCompleted", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.error,
          });
        })
      );
  }
  login(data): Observable<any> {
    let body = new HttpParams()
      .set("login_id", data.email.trim())
      .set("password", data.password.trim())
      .set("device_id", data.device_id.trim())
      .set("dd", JSON.stringify(data.dd))
      .set("dod", JSON.stringify(data.dod));

    if (data.one_signal_id) {
      body = body.set("one_signal_id", data.one_signal_id);
    }
    return this.http
      .post(environment.authApiUrl + "login", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.error,
          });
        })
      );
  }
  forgotPassword(data: any): Observable<any> {
    const body = new HttpParams()
      .set("email", data.email.toLowerCase())
      .set("base_url", this.appConstant.baseUrl);

    return this.http
      .post(environment.authApiUrl + "forgotPassword", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            message: error.error.message,
            datas: error.statusText,
          });
        })
      );
  }
  resendOTPservice(data: any): Observable<any> {
    let decryptedData;
    if (localStorage.getItem("signup_first")) {
      decryptedData = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("signup_first"),
          environment.secretkey
        ).toString(CryptoJS.enc.Utf8)
      );
    }

    const body = new HttpParams()
      .set("mobile_number", decryptedData.mobile_number)
      .set("email", decryptedData.email)
      .set("type", decryptedData.type)
      .set("country_code", decryptedData.country_code);

    return this.http
      .post(environment.apiBaseUrl + "resendOTP", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.statusText,
          });
        })
      );
  }

  resetPassword(data: any): Observable<any> {
    const body = new HttpParams()
      .set("password", data.password)
      .set("token", data.token);
    return this.http
      .put(environment.authApiUrl + "resetPassword", body, this.option)
      .pipe(
        map((data) => {
          return data;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.error,
          });
        })
      );
  }

  googleLogin(data: any): Observable<any> {
    const body = new HttpParams()
      .set("access_token", data.access_token)
      .set("email", data.email)
      .set("name", data.name)
      .set("image", data.image)
      .set("social_type", data.social_type)
      .set("device_type", data.device_type)
      .set("device_id", data.device_id)
      .set("one_signal_id", data.one_signal_id);
    return this.http
      .post(environment.authApiUrl + "googleLogin", body, this.option)
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.error,
          });
        })
      );
  }

  fbLogin(data: any): Observable<any> {
    const body = new HttpParams()
      .set("access_token", data.access_token)
      .set("email", data.email)
      .set("name", data.name)
      .set("social_type", data.social_type)
      .set("image", data.image)
      .set("device_type", data.device_type)
      .set("device_id", data.device_id)
      .set("one_signal_id", data.one_signal_id);
    return this.http
      .post(environment.authApiUrl + "faceBookLogin", body, this.option)
      .pipe(
        catchError((error) => {
          return throwError({
            status: error.status,
            datas: error.error,
          });
        })
      );
  }
}
